export enum MediaFileType {
  images = "images",
  fliers = "fliers",
  floorplans = "floorPlans",
}

export const ADDRESS_FIELD_ORDER = [
  "name",
  "address1",
  "address2",
  "city",
  "stateProvince",
  "postalCode",
];

export const LEASE_COMP_PINNED_FIELD_ORDER = [
  "propertyName",
  "propertyAddress",
  "propertyCity",
  "propertyState",
  "propertyPostalCode",
];
